<template>
  <div
    class="facet single-facet"
    :class="{ required: facet.required, error: !valid }"
    @click="openSelector"
  >
    <h5>{{ facet.name }}</h5>
    <div class="preference" :class="{ pending: !selected.id }">
      <span>{{ selected.value }}</span>

      <price-modifier :choice="selected"></price-modifier>
    </div>

    <div class="bubble" v-show="selecting" @click="closeChoices()">
      <div class="the-bubble" @click="closeChoices()" v-show="selecting">
        <div class="checklist scroll">
          <ul>
            <li v-for="choice in facet.choices.data" @click="select(choice)">
              {{ choice.value }}

              <price-modifier :choice="choice"></price-modifier>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defer } from 'lodash';
import Tether from 'tether';
import { isNonZero } from 'src/utilities';
import ActsAsFacet from 'mixins/ActsAsFacet';
import Stash from 'src/stash';

const defaultChoice = { id: null, value: '​Select', srp_amount: 0 };

const isQuantity = facet => facet.name.toLowerCase() === 'quantity';

const defaultOptionFor = facet => {
  if (isQuantity(facet)) {
    return (
      _(facet.choices.data).find(c => parseInt(c.id, 10) === 1) || defaultOption
    );
  }

  // check for a default option
  return _(facet.choices.data).find(c => !!c.default) || defaultOption;
};

export default {
  mixins: [ActsAsFacet],

  ready() {
    this.tether = new Tether({
      element: this.$el.querySelector('.the-bubble'),
      target: this.$el,
      attachment: 'top center',
      offset: '1px 0',
      optimizations: {
        moveElement: false,
      },
    });
  },

  detached() {
    this.tether.destroy();

    [].slice
      .call(document.querySelectorAll('.the-bubble'))
      .forEach(el => el.parentNode.removeChild(el));
  },

  data() {
    return {
      selecting: false,
      tether: null,
    };
  },

  watch: {
    selecting(v) {
      this.tether.element.classList.toggle('hidden', !v);
    },
  },

  computed: {
    selected() {
      const preference = this.state.preferences.find(
        p => p.facet_id === this.facet.id
      );

      if (!preference) {
        return defaultChoice;
      }

      // The precision is used here to accomodate fractional quantities. The precision
      // the server returns for 1/3 differs from what the src/stubs.js file provides.
      return (
        this.choices.find(
          c => c.id.toPrecision(3) === preference.choice_id.toPrecision(3)
        ) || defaultChoice
      );
    },
  },

  methods: {
    select(choice) {
      Stash.addPreference(this.facet, choice);
      this.closeChoices();
    },

    closeChoices() {
      this.$nextTick(() => (this.selecting = false));
    },

    openSelector() {
      this.selecting = true;

      defer(Tether.position);
    },

    validate() {
      return (this.valid = !this.facet.required || this.selected.id !== null);
    },

    isNonZero,
  },
};
</script>

<style lang="scss">
.facet {
  border: 1px solid #aaa;
  border-radius: 6px;
  padding: 10px;
  text-align: center;
  margin: 10px 20px;
  min-width: 200px;
  background: #fafafa;

  h5 {
    color: #444;
    font-weight: bold;
    padding: 0 0 5px;
    margin: 0;
  }

  &.required h5:after {
    content: '*';
    color: #ef3e29;
  }

  &.error {
    border-color: #ef3e29;
  }
}

.the-bubble {
  z-index: 99999;

  background: #f5f5f5;
  border: 1px solid #aaa;
  min-width: 175px;
  border-radius: 0 0 6px 6px;
  overflow: hidden;

  .scroll {
    max-height: 200px;
    overflow-x: hidden;
    overflow-y: auto;
  }

  ul,
  li {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  li {
    padding: 10px;
    text-align: center;

    &:nth-child(even) {
      background-color: #efefef;
    }
  }
}

.multi-facet {
  ul,
  li {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  ul {
    display: flex;
    flex-flow: column nowrap;
    align-items: flex-start;
  }

  li {
    $size: 24px;

    margin: 0 10px 15px;
    padding-left: 30px;
    position: relative;
    text-align: left;

    &:before {
      content: ' ';
      border: 1px solid #333;
      display: block;
      width: $size;
      height: $size;
      top: 0;
      left: 0;
      position: absolute;
      border-radius: 3px;
      background-color: #eee;
    }

    &.selected:before {
      background-image: url(~src/assets/images/icon-check.svg);
      background-color: #ed4033;
      background-repeat: no-repeat;
      background-size: $size * 0.6;
      background-position: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// SingleFacet.vue?24c2b6c3